import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Botonera from '../../components/atoms/Footer';
import { properties } from '../../../utils/properties';
import TagManagerUtils from '../../../utils/TagManagerUtils';
import { verificacionActions } from '../../../application/actions/verificacion';
import { ofertaActions } from '../../../application/actions/oferta';
import ComprobanteTemplate from '../../components/templates/Comprobante';
import { TipoProducto } from '../../../utils/TipoProducto';

const Step5 = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [fechaCreacion, setFechaCreacion] = useState('');

  const [state] = useState({
    "menuPosition": 5,
    "botonera": [{ nameUno: "", nameDos: properties.irCoopeuch }]
  })

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);
  const storeDataOferta = useSelector((store) => store.entities.oferta.response);

  useEffect(() => {
    if (storeDataVerificacion.length === 0) {
      dispatch(verificacionActions.verificacion({ trackId: window.localStorage.getItem('track_id') }));
    }
  
    if (storeDataOferta.length === 0) {
      dispatch(ofertaActions.ofertaCreate({ trackId: window.localStorage.getItem('track_id') }));
    }
  }, []);

  const tipoTarjetaFn = () => {
    let dataPersist = {}
    if ('data' in storeDataOferta) dataPersist = storeDataOferta;
    if ('data' in storeDataVerificacion && Object.keys(dataPersist).length === 0) dataPersist = storeDataVerificacion;
    const { data } = dataPersist;
    const { tipoTarjeta } = data;
    let tarjeta;
    if (tipoTarjeta === TipoProducto.black) {
      tarjeta = "Mastercard internacional Negra";
    } else {
      tarjeta = "Mastercard internacional Dorada";
    }
    return tarjeta
  }

  const volveraCoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
    const { data } = storeDataVerificacion;
    const { socio, convenio } = data;
    if(socio && convenio){
     const TextoSocio = "Socio convenio";
      TagManagerUtils.triggerEventMetodo("trigger_event", TextoSocio, "/comprobante", "Click", "Volver a coopeuch.cl");
    
    }else if(socio){
      const TextoSocio = "Socio";
      TagManagerUtils.triggerEventMetodo("trigger_event", TextoSocio, "/comprobante", "Click", "Volver a coopeuch.cl");
      
    }else{
      const TextoSocio = "No Socio";
      TagManagerUtils.triggerEventMetodo("trigger_event", TextoSocio, "/comprobante", "Click", "Volver a coopeuch.cl");
    }

  }

  const verificar = () => {
    window.location.href = properties.urlCoopeuch;
    const { socio, convenio } = storeDataVerificacion;
    if (socio && convenio) {
      TagManagerUtils.triggerEventMetodoTwo(
        "trigger_event",
        "Socio convenio",
        "/solicitud-tarjeta-credito/paso4",
        "Click",
        "Confirmar solicitud",
        tipoTarjetaFn()
      );
    } else {
      TagManagerUtils.triggerEventMetodoTwo("trigger_event", "Socio", "/solicitud-tarjeta-credito/paso4", "Click", "Confirmar solicitud", tipoTarjetaFn());
    }
  }

  useEffect(() => {
    if(Object.keys(storeDataVerificacion).length){
      const { socio, convenio } = storeDataVerificacion;
      if (socio && convenio) {
        TagManagerUtils.vpvMetodoTwo("vpv", "/solicitud-tarjeta-credito/paso5", "Socio covenio", tipoTarjetaFn());
      } else {
        TagManagerUtils.vpvMetodoTwo("vpv", "/solicitud-tarjeta-credito/paso5", "Socio", tipoTarjetaFn());
      }
    }
  }, [storeDataVerificacion]);

  useEffect(() => {
    if ('code' in storeDataOferta && storeDataOferta.code === -1) {
      window.localStorage.setItem('paso', '/comprobante');
      history.push('/error-conexion');
    }
    if('data' in storeDataOferta){
      setFechaCreacion(storeDataOferta.data.fechaCreacion);
    }
  }, [storeDataOferta]);

  const { menuPosition, botonera } = state;
  
  return (
    <>
      {Object.keys(storeDataOferta).length > 0 &&
        <>
          <ComprobanteTemplate
            activeMenu={menuPosition}
            fechaCreacionSolitud={fechaCreacion}
          />
          <Botonera
            tituloboton={botonera}
            volverHome={volveraCoopeuch}
            verificarFunction={verificar}
            estadoBotonUno
            estadoBotonDos={false}
            activeMenu={menuPosition}
          />
        </>}
    </>
  )
};

export default Step5;
